import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-just-bet-homepge',
  templateUrl: './just-bet-homepge.component.html',
  styleUrls: ['./just-bet-homepge.component.css']
})
export class JustBetHomepgeComponent implements OnInit {

  constructor( private router:Router) { }

  ngOnInit() {
  }
  
  goToPath(path) {
    this.router.navigateByUrl(path);
  }

}
